var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.instrument
        ? [
            _c(
              "div",
              { staticClass: "panel wraper panel-gray" },
              [
                _c(
                  "div",
                  { staticClass: "panel-header" },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: _vm.transName || "slide-l",
                          mode: "out-in"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            key: _vm.$route.params.id,
                            staticClass: "panel-title"
                          },
                          [_c("unit-path", { attrs: { id: _vm.id } })],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: { name: _vm.transName || "slide-l", mode: "out-in" }
                  },
                  [
                    _c(
                      "div",
                      { key: _vm.$route.params.id, staticClass: "panel-body" },
                      [
                        _vm.instrument.lastEdited
                          ? _c("p", { staticClass: "in-top" }, [
                              _c(
                                "small",
                                { staticClass: "view-label" },
                                [
                                  _c("q-icon", {
                                    attrs: { name: "fas fa-user-edit" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.editor) +
                                      " " +
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.instrument.lastEdited
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.instrument.name
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Название")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.instrument.name))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.instrument.serial
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Серийный номер")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.instrument.serial))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.instrument.dateInstall
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Дата установки")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      _vm.instrument.dateInstall
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.instrument.comment
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Заметки")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.instrument.comment))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("media-bar", {
                          attrs: { medias: _vm.mediasCopy },
                          on: { selectMedia: _vm.showAttach }
                        }),
                        _vm._v(" "),
                        _vm.cases
                          ? _c("p", { staticClass: "subtitle" }, [
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(
                                  "Кейсы (" + _vm._s(_vm.cases.length) + ")"
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "panel-list" },
                          _vm._l(_vm.cases, function(item, ind) {
                            return _c("case-item", {
                              key: ind,
                              attrs: { item: item }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-btn", {
                  staticClass: "mobile-hide",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-hold", {
                  staticClass: "mobile-only",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("media-modal", {
              ref: "mediaModal",
              attrs: { done: _vm.createAttach }
            })
          ]
        : [
            _c(
              "div",
              { staticClass: "row justify-center" },
              [
                _c("q-spinner-dots", { attrs: { size: 100, color: "primary" } })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("mediator", {
        ref: "mediator",
        attrs: { editEnabled: _vm.notReader },
        on: {
          mediaEdited: _vm.mediaEdited,
          mediaDeleted: _vm.mediaDeleted,
          doNext: _vm.doNext
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c2b578b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2b578b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instrument-view.vue
// module id = null
// module chunks = 